/* src/app/shared/components/layout/user-menu/user-menu.component.scss */
.user-menu {
  min-width: 200px;
  padding-top: 8px;
}
.user-menu-header {
  display: flex;
  flex-flow: column;
}
.user-menu-name {
  font-weight: bold;
}
.user-menu-phone {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.75);
}
.user-menu .mat-mdc-menu-item .mat-icon {
  font-size: 1.2rem;
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 10px;
}
/*# sourceMappingURL=user-menu.component.css.map */
